<!-- eslint-disable -->
<script>
import VehicleSvg from '@/components/VehicleSvg.vue'

export default {
  name: 'GameBoard',
  components: {
    VehicleSvg,
  },
  data() {
    return {
      // ----------------------------------------------------
      // 1. 고정 차단막 데이터 (주황색 1x1 장애물 - 1~14 기반 좌표)
      // ----------------------------------------------------
      obstacles: [
        { id: 'obs-1', x: 7, y: 3 },
        { id: 'obs-2', x: 2, y: 7 },
        { id: 'obs-3', x: 12, y: 9 },
        { id: 'obs-4', x: 9, y: 13 },
      ],

      // ----------------------------------------------------
      // 2. 전달된 JSON 원본 데이터
      // ----------------------------------------------------
      rawVehicleData: [
        { id: 1, color: 'gray', type: 'car', start: { x: 4, y: 1 }, end: { x: 5, y: 1 } },
        { id: 2, color: 'gray', type: 'bus', start: { x: 11, y: 1 }, end: { x: 13, y: 1 } },
        { id: 3, color: 'gray', type: 'car', start: { x: 2, y: 2 }, end: { x: 3, y: 2 } },
        { id: 4, color: 'gray', type: 'bus', start: { x: 5, y: 2 }, end: { x: 7, y: 2 } },
        { id: 5, color: 'gray', type: 'car', start: { x: 10, y: 2 }, end: { x: 11, y: 2 } },
        { id: 6, color: 'gray', type: 'bus', start: { x: 14, y: 2 }, end: { x: 14, y: 4 } },
        { id: 7, color: 'gray', type: 'car', start: { x: 1, y: 3 }, end: { x: 1, y: 4 } },
        { id: 8, color: 'gray', type: 'bus', start: { x: 2, y: 3 }, end: { x: 4, y: 3 } },
        { id: 9, color: 'gray', type: 'car', start: { x: 5, y: 3 }, end: { x: 6, y: 3 } },
        { id: 10, color: 'gray', type: 'car', start: { x: 9, y: 3 }, end: { x: 10, y: 3 } },
        { id: 11, color: 'gray', type: 'bus', start: { x: 2, y: 4 }, end: { x: 2, y: 6 } },
        { id: 12, color: 'gray', type: 'bus', start: { x: 8, y: 4 }, end: { x: 10, y: 4 } },
        { id: 13, color: 'gray', type: 'car', start: { x: 13, y: 4 }, end: { x: 13, y: 5 } },
        { id: 14, color: 'yellow', type: 'car', start: { x: 6, y: 5 }, end: { x: 7, y: 5 } },
        { id: 15, color: 'red', type: 'car', start: { x: 10, y: 5 }, end: { x: 10, y: 6 } },
        { id: 16, color: 'gray', type: 'bus', start: { x: 12, y: 5 }, end: { x: 12, y: 7 } },
        { id: 17, color: 'gray', type: 'car', start: { x: 14, y: 6 }, end: { x: 14, y: 7 } },
        { id: 18, color: 'red', type: 'car', start: { x: 5, y: 6 }, end: { x: 5, y: 7 } },
        { id: 19, color: 'yellow', type: 'car', start: { x: 8, y: 6 }, end: { x: 9, y: 6 } },
        { id: 20, color: 'gray', type: 'car', start: { x: 3, y: 6 }, end: { x: 3, y: 7 } },
        { id: 21, color: 'gray', type: 'bus', start: { x: 1, y: 8 }, end: { x: 3, y: 8 } },
        { id: 22, color: 'yellow', type: 'car', start: { x: 5, y: 8 }, end: { x: 6, y: 8 } },
        { id: 23, color: 'yellow', type: 'car', start: { x: 8, y: 8 }, end: { x: 8, y: 9 } },
        { id: 24, color: 'gray', type: 'car', start: { x: 11, y: 8 }, end: { x: 11, y: 9 } },
        { id: 25, color: 'gray', type: 'bus', start: { x: 13, y: 8 }, end: { x: 13, y: 10 } },
        { id: 26, color: 'gray', type: 'car', start: { x: 1, y: 9 }, end: { x: 1, y: 10 } },
        { id: 27, color: 'gray', type: 'bus', start: { x: 3, y: 9 }, end: { x: 3, y: 11 } },
        { id: 28, color: 'red', type: 'car', start: { x: 6, y: 9 }, end: { x: 6, y: 10 } },
        { id: 29, color: 'red', type: 'car', start: { x: 9, y: 10 }, end: { x: 10, y: 10 } },
        { id: 30, color: 'gray', type: 'car', start: { x: 14, y: 10 }, end: { x: 14, y: 11 } },
        { id: 31, color: 'gray', type: 'car', start: { x: 5, y: 11 }, end: { x: 6, y: 11 } },
        { id: 32, color: 'gray', type: 'bus', start: { x: 9, y: 11 }, end: { x: 11, y: 11 } },
        { id: 33, color: 'gray', type: 'bus', start: { x: 2, y: 12 }, end: { x: 4, y: 12 } },
        { id: 34, color: 'gray', type: 'car', start: { x: 7, y: 12 }, end: { x: 8, y: 12 } },
        { id: 35, color: 'gray', type: 'car', start: { x: 12, y: 12 }, end: { x: 13, y: 12 } },
        { id: 36, color: 'gray', type: 'car', start: { x: 1, y: 13 }, end: { x: 2, y: 13 } },
        { id: 37, color: 'gray', type: 'bus', start: { x: 5, y: 13 }, end: { x: 7, y: 13 } },
        { id: 38, color: 'gray', type: 'car', start: { x: 10, y: 13 }, end: { x: 11, y: 13 } },
        { id: 39, color: 'gray', type: 'car', start: { x: 2, y: 14 }, end: { x: 3, y: 14 } },
        { id: 40, color: 'gray', type: 'car', start: { x: 8, y: 14 }, end: { x: 9, y: 14 } },
        { id: 41, color: 'gray', type: 'bus', start: { x: 11, y: 14 }, end: { x: 13, y: 14 } },
      ],

      // ----------------------------------------------------
      // 3. 게임 상태 및 룰 관리 변수
      // ----------------------------------------------------

      firstPlayer: 'red',
      currentTurn: 'red',
      gamePhase: 'PLACEMENT_STAGE_1',
      placedFirstTeamCount: 0,
      lastMovedVehicleId: null,

      redScore: 0,
      yellowScore: 0,
      winner: null,

      // 팀원별 제한시간 상태 및 개별 이동 상태 기록
      teamTimers: {
        red: { activeMemberIndex: 0, times: [60, 60], hasMovedHistory: [false, false] },
        yellow: { activeMemberIndex: 0, times: [60, 60], hasMovedHistory: [false, false] },
      },

      timeouts: {
        red: { hasUsed: false, remainingTime: 300 },
        yellow: { hasUsed: false, remainingTime: 300 },
      },

      isTimeoutActive: false,
      activeTimeoutTeam: null,
      timerInterval: null,

      selectedVehicleId: null,
      moveOptions: [],
      vehicleList: [],
    }
  },
  computed: {
    activeVehicleList() {
      return this.vehicleList.filter((v) => !v.escaped)
    },

    // WebStorm 파싱 에러 방지용: template 조건문 태그 제거를 위한 가이드 이동 옵션 필터링
    visibleMoveOptions() {
      return this.isTimeoutActive ? [] : this.moveOptions
    },

    statusMessage() {
      if (this.gamePhase === 'GAME_OVER') {
        return `🎉 축하합니다! ${this.winner ? this.winner.toUpperCase() : ''} TEAM이 승점 3점을 먼저 획득하여 승리했습니다!`
      }

      if (this.isTimeoutActive && this.activeTimeoutTeam) {
        return `⏱️ ${this.activeTimeoutTeam.toUpperCase()} TEAM 5분 작전 타임아웃 진행 중... (${this.formatTime(this.timeouts[this.activeTimeoutTeam].remainingTime)})`
      }

      const secondPlayerText = this.firstPlayer === 'red' ? 'YELLOW' : 'RED'
      const firstPlayerText = this.firstPlayer === 'red' ? 'RED' : 'YELLOW'

      if (this.gamePhase === 'PLACEMENT_STAGE_1') {
        return `[배치 1단계] 후공팀(${secondPlayerText})이 8개 위치 중 아무곳이나 선택하여 선공팀(${firstPlayerText})의 차 3대를 배치하세요 (${this.placedFirstTeamCount}/3)`
      } else if (this.gamePhase === 'PLACEMENT_STAGE_2') {
        return `[배치 2단계] 선공팀(${firstPlayerText})이 남은 위치 중 1곳을 선택하여 마지막 차를 배치하세요`
      } else {
        const activeMemberNum = this.teamTimers[this.currentTurn].activeMemberIndex + 1
        return `[본 게임] ${this.currentTurn.toUpperCase()} TEAM (팀원 ${activeMemberNum}) 턴입니다.`
      }
    },
  },
  created() {
    this.vehicleList = this.rawVehicleData.map((item) => {
      const isHorizontal = item.start.y === item.end.y
      const direction = isHorizontal ? 'H' : 'V'
      const length = isHorizontal
          ? item.end.x - item.start.x + 1
          : item.end.y - item.start.y + 1

      const x = item.start.x - 1
      const y = item.start.y - 1

      const isSlot = item.color === 'red' || item.color === 'yellow'

      return {
        id: item.id,
        color: isSlot ? 'gray' : item.color,
        type: item.type,
        length,
        direction,
        x,
        y,
        isPlaced: !isSlot,
        isSlot,
        escaped: false,
      }
    })
  },
  mounted() {
    this.startTimer()
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval)
  },
  methods: {
    startTimer() {
      if (this.timerInterval) clearInterval(this.timerInterval)

      this.timerInterval = window.setInterval(() => {
        if (this.gamePhase === 'GAME_OVER') return

        // 1. 타임아웃 활성화 중 카운트다운
        if (this.isTimeoutActive && this.activeTimeoutTeam) {
          const tState = this.timeouts[this.activeTimeoutTeam]
          if (tState.remainingTime > 0) {
            tState.remainingTime--
          } else {
            this.endTimeout()
            alert(`⏱️ ${this.activeTimeoutTeam.toUpperCase()} TEAM의 5분 타임아웃이 종료되었습니다. 경기를 재개합니다.`)
          }
          return
        }

        // 2. 본 게임 진행 시 플레이어 제한시간 카운트다운
        if (this.gamePhase === 'PLAYING') {
          const team = this.currentTurn
          const timerState = this.teamTimers[team]
          const memberIdx = timerState.activeMemberIndex

          if (timerState.times[memberIdx] > 0) {
            // Vue 2 배열 반응성 한계 극복을 위한 $set 사용
            this.$set(timerState.times, memberIdx, timerState.times[memberIdx] - 1)
          } else {
            // 🔴 1분 제한시간(60초)이 완전 소모된 시점 판정
            const currentMemberNum = memberIdx + 1
            const hasMoved = timerState.hasMovedHistory[memberIdx]

            if (!hasMoved) {
              // 1️⃣ 이번 60초 동안 한 번도 안 움직인 경우:
              // - 안 움직인 현재 팀원 시간 60초로 복구
              this.$set(timerState.times, memberIdx, 60)

              // - 🎯 핵심: 다음 우리 팀 턴에 안 움직인 팀원이 아니라 '다른 팀원'이 하도록 미리 교체!
              timerState.activeMemberIndex = memberIdx === 0 ? 1 : 0
              const nextMemberNum = timerState.activeMemberIndex + 1

              alert(`⏱️ ${team.toUpperCase()} TEAM (팀원 ${currentMemberNum})이 한 번도 움직이지 않고 시간을 소모했습니다!\n상대 팀으로 턴이 넘어가며, 다음 턴에는 팀원 ${nextMemberNum}(이)가 출전합니다.`)

              // - 상대 팀으로 턴 전환
              this.switchTurn()
            } else {
              // 2️⃣ 과거에 1번이라도 움직인 기록이 있는 경우:
              this.$set(timerState.times, memberIdx, 60) // 시간 60초로 초기화
              this.$set(timerState.hasMovedHistory, memberIdx, false) // 이동 기록 초기화

              timerState.activeMemberIndex = memberIdx === 0 ? 1 : 0 // 동일 팀 내 순서 교체 (0 <-> 1)

              const nextMemberNum = timerState.activeMemberIndex + 1
              alert(`⏱️ ${team.toUpperCase()} TEAM 팀원 ${currentMemberNum}의 제한시간이 모두 소모되었습니다.\n동일 팀 팀원 ${nextMemberNum}(으)로 순서가 교체됩니다.`)
            }
          }
        }
      }, 1000)
    },

    requestTimeout(team) {
      if (this.gamePhase !== 'PLAYING') {
        alert('게임 진행 중에만 타임아웃을 요청할 수 있습니다.')
        return
      }

      if (this.currentTurn !== team) {
        alert('본인 팀의 턴일 때만 타임아웃을 요청할 수 있습니다.')
        return
      }

      if (this.timeouts[team].hasUsed) {
        alert('이미 타임아웃을 사용하셨습니다. (팀당 1회 제한)')
        return
      }

      this.timeouts[team].hasUsed = true
      this.isTimeoutActive = true
      this.activeTimeoutTeam = team

      this.selectedVehicleId = null
      this.moveOptions = []
    },

    endTimeout() {
      this.isTimeoutActive = false
      this.activeTimeoutTeam = null
    },

    switchTurn() {
      // 1. 턴 교체
      this.currentTurn = this.currentTurn === 'red' ? 'yellow' : 'red'

      // 2. 선택 상태 및 이동 가이드 초기화
      this.selectedVehicleId = null
      this.moveOptions = []
    },

    formatTime(seconds) {
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      return `${m}:${s < 10 ? '0' : ''}${s}`
    },

    isCellOccupied(x, y, ignoreVehicleId) {
      if (x < 0 || x >= 14 || y < 0 || y >= 14) return true

      const hasObstacle = this.obstacles.some((obs) => obs.x - 1 === x && obs.y - 1 === y)
      if (hasObstacle) return true

      return this.vehicleList.some((v) => {
        if (!v.isPlaced || v.escaped || v.id === ignoreVehicleId) return false
        if (v.direction === 'H') {
          return y === v.y && x >= v.x && x < v.x + v.length
        } else {
          return x === v.x && y >= v.y && y < v.y + v.length
        }
      })
    },

    handleVehicleClick(clickedVeh) {
      if (clickedVeh.escaped || this.isTimeoutActive) return

      if (this.gamePhase !== 'PLAYING') {
        this.handlePlacementClick(clickedVeh)
        return
      }

      if (clickedVeh.id === this.lastMovedVehicleId) {
        alert('직전 턴에 움직인 차량은 이번 턴에 움직일 수 없습니다!')
        return
      }

      if (clickedVeh.color !== 'gray' && clickedVeh.color !== this.currentTurn) {
        alert('상대팀 차량은 움직일 수 없습니다!')
        return
      }

      if (this.selectedVehicleId === clickedVeh.id) {
        this.selectedVehicleId = null
        this.moveOptions = []
        return
      }

      this.selectedVehicleId = clickedVeh.id
      this.calculateSlideDestinations(clickedVeh)
    },

    handlePlacementClick(clickedVeh) {
      if (clickedVeh.isPlaced || !clickedVeh.isSlot) return

      const firstTeamColor = this.firstPlayer
      const secondTeamColor = this.firstPlayer === 'red' ? 'yellow' : 'red'

      if (this.gamePhase === 'PLACEMENT_STAGE_1') {
        clickedVeh.color = firstTeamColor
        clickedVeh.isPlaced = true
        this.placedFirstTeamCount++

        if (this.placedFirstTeamCount === 3) {
          this.gamePhase = 'PLACEMENT_STAGE_2'
        }
      } else if (this.gamePhase === 'PLACEMENT_STAGE_2') {
        clickedVeh.color = firstTeamColor
        clickedVeh.isPlaced = true

        this.vehicleList.forEach((v) => {
          if (v.isSlot && !v.isPlaced) {
            v.color = secondTeamColor
            v.isPlaced = true
          }
        })

        this.gamePhase = 'PLAYING'
        this.currentTurn = this.firstPlayer
        this.startTimer()
      }
    },

    calculateSlideDestinations(v) {
      const options = []

      if (v.direction === 'H') {
        let targetX = v.x
        while (targetX - 1 >= 0 && !this.isCellOccupied(targetX - 1, v.y, v.id)) {
          targetX--
        }
        if (targetX !== v.x) {
          options.push({ x: targetX, y: v.y, label: '←' })
        }

        targetX = v.x
        while (targetX + v.length < 14 && !this.isCellOccupied(targetX + v.length, v.y, v.id)) {
          targetX++
        }
        if (targetX !== v.x) {
          options.push({ x: targetX, y: v.y, label: '→' })
        }
      } else {
        let targetY = v.y
        while (targetY - 1 >= 0 && !this.isCellOccupied(v.x, targetY - 1, v.id)) {
          targetY--
        }
        if (targetY !== v.y) {
          options.push({ x: v.x, y: targetY, label: '↑' })
        }

        targetY = v.y
        while (targetY + v.length < 14 && !this.isCellOccupied(v.x, targetY + v.length, v.id)) {
          targetY++
        }
        if (targetY !== v.y) {
          options.push({ x: v.x, y: targetY, label: '↓' })
        }
      }

      this.moveOptions = options
    },

    moveVehicle(opt) {
      if (!this.selectedVehicleId || this.isTimeoutActive) return

      const targetVeh = this.vehicleList.find((v) => v.id === this.selectedVehicleId)
      if (targetVeh) {
        targetVeh.x = opt.x
        targetVeh.y = opt.y
        this.lastMovedVehicleId = targetVeh.id

        // 현재 팀원의 이동 기록을 true로 업데이트
        const team = this.currentTurn
        const memberIdx = this.teamTimers[team].activeMemberIndex
        this.$set(this.teamTimers[team].hasMovedHistory, memberIdx, true)

        const isAtOuterWall =
            targetVeh.x === 0 ||
            targetVeh.y === 0 ||
            (targetVeh.direction === 'H' && targetVeh.x + targetVeh.length === 14) ||
            (targetVeh.direction === 'V' && targetVeh.y + targetVeh.length === 14)

        if (isAtOuterWall && (targetVeh.color === 'red' || targetVeh.color === 'yellow')) {
          targetVeh.escaped = true

          if (targetVeh.color === 'red') {
            this.redScore++
          } else if (targetVeh.color === 'yellow') {
            this.yellowScore++
          }

          alert(`🚗 ${targetVeh.color.toUpperCase()} TEAM 차가 바깥벽에 도달하여 탈출 성공! (승점 +1)`)

          if (this.redScore >= 3) {
            this.winner = 'red'
            this.gamePhase = 'GAME_OVER'
            if (this.timerInterval) clearInterval(this.timerInterval)
            return
          } else if (this.yellowScore >= 3) {
            this.winner = 'yellow'
            this.gamePhase = 'GAME_OVER'
            if (this.timerInterval) clearInterval(this.timerInterval)
            return
          }
        }

        // 차를 정상 이동시킨 후 상대팀으로 턴 넘김 (시간은 일시정지 상태 유지)
        this.switchTurn()
      }
    },
  },
}
</script>

<template>
  <div class="game-container">
    <!-- 1. 좌측: 빨간팀 프로필 및 타이머/승점/타임아웃 영역 -->
    <div class="player-section left" :class="{ active: currentTurn === 'red' }">
      <div v-if="currentTurn === 'red'" class="turn-badge">선</div>
      <div class="avatar-icon red">
        <svg viewBox="0 0 100 100" class="user-svg">
          <circle cx="50" cy="35" r="22" fill="none" stroke="currentColor" stroke-width="6"></circle>
          <path d="M 15 85 C 15 60, 85 60, 85 85" fill="none" stroke="currentColor" stroke-width="6"></path>
        </svg>
      </div>
      <span class="player-name red">RED TEAM</span>

      <!-- 룰 2, 3: 플레이어 2명 타이머 표시 -->
      <div class="timer-box">
        <div
            class="timer-item"
            :class="{ active: currentTurn === 'red' && teamTimers.red.activeMemberIndex === 0 }"
        >
          <span class="p-label">팀원 1:</span>
          <span class="p-time">{{ formatTime(teamTimers.red.times[0]) }}</span>
        </div>
        <div
            class="timer-item"
            :class="{ active: currentTurn === 'red' && teamTimers.red.activeMemberIndex === 1 }"
        >
          <span class="p-label">팀원 2:</span>
          <span class="p-time">{{ formatTime(teamTimers.red.times[1]) }}</span>
        </div>
      </div>

      <!-- 신규 룰: 5분 타임아웃 요청 버튼 및 상태 -->
      <div class="timeout-box">
        <button
            v-if="!isTimeoutActive || activeTimeoutTeam !== 'red'"
            class="timeout-btn red"
            :disabled="timeouts.red.hasUsed || currentTurn !== 'red' || gamePhase !== 'PLAYING'"
            @click="requestTimeout('red')"
        >
          ⏱️ 타임아웃 ({{ timeouts.red.hasUsed ? '사용완료' : '5분' }})
        </button>
        <button
            v-else-if="isTimeoutActive && activeTimeoutTeam === 'red'"
            class="timeout-btn resume"
            @click="endTimeout"
        >
          ▶ 작전 종료 (이어서 진행)
        </button>
      </div>

      <!-- 룰 1: 탈출 차량 승점 및 아이콘 표시 -->
      <div class="score-display">
        <span class="score-title">승점: {{ redScore }} / 3</span>
        <div class="escaped-icons">
          <div v-for="s in redScore" :key="`red-score-${s}`" class="mini-escaped-car red">🚘</div>
        </div>
      </div>
    </div>

    <!-- 2. 중앙: 메인 보드 & 게임 메시지 -->
    <div class="board-area">
      <!-- 상단 상주 상태 메시지 바 -->
      <div class="status-bar" :class="{ 'timeout-active': isTimeoutActive }">
        {{ statusMessage }}
      </div>

      <div class="board-wrapper">
        <div class="grid-board">
          <!-- 14x14 배경 셀 -->
          <div v-for="r in 14" :key="`row-${r}`" class="grid-row">
            <div v-for="c in 14" :key="`cell-${r}-${c}`" class="grid-cell"></div>
          </div>

          <!-- 중앙 6x6 주황색 영역 -->
          <div class="center-highlight-box"></div>

          <!-- 고정 장애물 (주황색 차단막) -->
          <div
              v-for="obs in obstacles"
              :key="obs.id"
              class="obstacle-item"
              :style="{ gridColumnStart: obs.x, gridRowStart: obs.y }"
          >
            <svg viewBox="0 0 40 40" class="obstacle-svg">
              <path d="M 5 8 L 8 4 L 32 4 L 35 8 L 38 10 L 38 13 L 35 15 L 32 18 L 8 18 L 5 15 L 2 13 L 2 10 Z" class="obs-block-body"></path>
              <line x1="8" y1="11" x2="32" y2="11" class="obs-center-line"></line>
              <path d="M 5 28 L 8 24 L 32 24 L 35 28 L 38 30 L 38 33 L 35 35 L 32 38 L 8 38 L 5 35 L 2 33 L 2 30 Z" class="obs-block-body"></path>
              <line x1="8" y1="31" x2="32" y2="31" class="obs-center-line"></line>
            </svg>
          </div>

          <!-- 이동 대상 위치 가이드 버튼 -->
          <div
              v-for="(opt, idx) in visibleMoveOptions"
              :key="`opt-${idx}`"
              class="move-guide-item"
              :style="{ gridColumnStart: opt.x + 1, gridRowStart: opt.y + 1 }"
              @click="moveVehicle(opt)"
          >
            <div class="move-btn">{{ opt.label }}</div>
          </div>

          <!-- 차량 및 슬롯 요소 -->
          <div
              v-for="v in activeVehicleList"
              :key="v.id"
              class="vehicle-item"
              :class="[
              v.color,
              v.direction === 'H' ? 'horizontal' : 'vertical',
              v.type,
              {
                'unplaced-slot': !v.isPlaced,
                selected: selectedVehicleId === v.id,
                disabled: v.id === lastMovedVehicleId || isTimeoutActive,
              },
            ]"
              :style="{
              gridColumn: v.direction === 'H' ? `${v.x + 1} / span ${v.length}` : `${v.x + 1} / span 1`,
              gridRow: v.direction === 'V' ? `${v.y + 1} / span ${v.length}` : `${v.y + 1} / span 1`,
            }"
              @click="handleVehicleClick(v)"
          >
            <!-- 직전에 움직인 차 표시용 라바콘 (룰 6) -->
            <div v-if="v.id === lastMovedVehicleId" class="traffic-cone-overlay">
              <svg viewBox="0 0 30 30" class="cone-svg">
                <polygon points="15,2 5,26 25,26" fill="#ff6001" stroke="#ffffff" stroke-width="1.5"></polygon>
                <line x1="9" y1="18" x2="21" y2="18" stroke="#ffffff" stroke-width="2.5"></line>
                <rect x="2" y="25" width="26" height="4" rx="1" fill="#334155"></rect>
              </svg>
            </div>

            <!-- 차량 SVG 하위 컴포넌트 호출 -->
            <VehicleSvg :type="v.type" :direction="v.direction" />
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 우측: 노란팀 프로필 및 타이머/승점/타임아웃 영역 -->
    <div class="player-section right" :class="{ active: currentTurn === 'yellow' }">
      <div v-if="currentTurn === 'yellow'" class="turn-badge">선</div>
      <div class="avatar-icon yellow">
        <svg viewBox="0 0 100 100" class="user-svg">
          <circle cx="50" cy="35" r="22" fill="none" stroke="currentColor" stroke-width="6"></circle>
          <path d="M 15 85 C 15 60, 85 60, 85 85" fill="none" stroke="currentColor" stroke-width="6"></path>
        </svg>
      </div>
      <span class="player-name yellow">YELLOW TEAM</span>

      <!-- 룰 2, 3: 플레이어 2명 타이머 표시 -->
      <div class="timer-box">
        <div
            class="timer-item"
            :class="{ active: currentTurn === 'yellow' && teamTimers.yellow.activeMemberIndex === 0 }"
        >
          <span class="p-label">팀원 1:</span>
          <span class="p-time">{{ formatTime(teamTimers.yellow.times[0]) }}</span>
        </div>
        <div
            class="timer-item"
            :class="{ active: currentTurn === 'yellow' && teamTimers.yellow.activeMemberIndex === 1 }"
        >
          <span class="p-label">팀원 2:</span>
          <span class="p-time">{{ formatTime(teamTimers.yellow.times[1]) }}</span>
        </div>
      </div>

      <!-- 신규 룰: 5분 타임아웃 요청 버튼 및 상태 -->
      <div class="timeout-box">
        <button
            v-if="!isTimeoutActive || activeTimeoutTeam !== 'yellow'"
            class="timeout-btn yellow"
            :disabled="timeouts.yellow.hasUsed || currentTurn !== 'yellow' || gamePhase !== 'PLAYING'"
            @click="requestTimeout('yellow')"
        >
          ⏱️ 타임아웃 ({{ timeouts.yellow.hasUsed ? '사용완료' : '5분' }})
        </button>
        <button
            v-else-if="isTimeoutActive && activeTimeoutTeam === 'yellow'"
            class="timeout-btn resume"
            @click="endTimeout"
        >
          ▶ 작전 종료 (이어서 진행)
        </button>
      </div>

      <!-- 룰 1: 탈출 차량 승점 및 아이콘 표시 -->
      <div class="score-display">
        <span class="score-title">승점: {{ yellowScore }} / 3</span>
        <div class="escaped-icons">
          <div v-for="s in yellowScore" :key="`yellow-score-${s}`" class="mini-escaped-car yellow">
            🚘
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.game-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-color: #121316;
  padding: 20px;
  gap: 40px;
  user-select: none;
}

.board-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.status-bar {
  background-color: #1e293b;
  color: #f8fafc;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 800;
  border: 1px solid #334155;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.status-bar.timeout-active {
  background-color: #7c2d12;
  border-color: #ff6001;
  color: #ffedd5;
  animation: pulse-border 1.5s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 4px rgba(255, 96, 1, 0.4);
  }
  50% {
    box-shadow: 0 0 16px rgba(255, 96, 1, 0.9);
  }
  100% {
    box-shadow: 0 0 4px rgba(255, 96, 1, 0.4);
  }
}

/* 프로필 스타일 */
.player-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  opacity: 0.4;
  transition: opacity 0.3s ease;
  min-width: 160px;
}

.player-section.active {
  opacity: 1;
}

.turn-badge {
  position: absolute;
  top: -20px;
  left: -20px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #dc2626;
  color: #ffffff;
  background: rgba(220, 38, 38, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 900;
}

.player-section.right .turn-badge {
  border-color: #eab308;
  background: rgba(234, 179, 8, 0.2);
}

.avatar-icon {
  width: 110px;
  height: 110px;
}
.avatar-icon.red {
  color: #dc2626;
}
.avatar-icon.yellow {
  color: #eab308;
}

.user-svg {
  width: 100%;
  height: 100%;
}

.player-name {
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 1px;
}
.player-name.red {
  color: #f87171;
}
.player-name.yellow {
  color: #facc15;
}

/* 타이머 UI 스타일 */
.timer-box {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.timer-item {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  font-weight: 700;
  color: #94a3b8;
  padding: 4px 6px;
  border-radius: 4px;
}

.timer-item.active {
  background: rgba(56, 189, 248, 0.2);
  color: #38bdf8;
  border: 1px solid #0284c7;
}

/* 신규: 타임아웃 버튼 UI 스타일 */
.timeout-box {
  width: 100%;
}

.timeout-btn {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 800;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.timeout-btn.red {
  background-color: rgba(220, 38, 38, 0.15);
  color: #f87171;
  border-color: #dc2626;
}

.timeout-btn.yellow {
  background-color: rgba(234, 179, 8, 0.15);
  color: #facc15;
  border-color: #eab308;
}

.timeout-btn.resume {
  background-color: #ff6001;
  color: #ffffff;
  border-color: #ea580c;
  box-shadow: 0 0 10px rgba(255, 96, 1, 0.6);
}

.timeout-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  border-color: #475569;
  color: #94a3b8;
  background-color: transparent;
}

/* 승점 및 탈출 차량 보드 스타일 */
.score-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.score-title {
  font-size: 0.9rem;
  font-weight: 800;
  color: #f1f5f9;
}

.escaped-icons {
  display: flex;
  gap: 6px;
  min-height: 28px;
}

.mini-escaped-car {
  font-size: 1.2rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));
}

/* 14x14 보드 레이아웃 */
.board-wrapper {
  background-color: #1a1a1a;
  padding: 8px;
  border: 4px solid #334155;
  border-radius: 6px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
}

.grid-board {
  display: grid;
  grid-template-columns: repeat(14, 42px);
  grid-template-rows: repeat(14, 42px);
  gap: 1px;
  width: 601px;
  height: 601px;
  background-color: transparent;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  overflow: hidden;
}

.grid-row {
  display: contents;
}

.grid-cell {
  background-color: #1a1c23;
  border: 1px solid rgba(255, 255, 255, 0.12);
  width: 42px;
  height: 42px;
  box-sizing: border-box;
}

/* 중앙 6x6 주황색 배치 영역 */
.center-highlight-box {
  position: absolute;
  grid-column: 5 / span 6;
  grid-row: 5 / span 6;
  width: 100%;
  height: 100%;
  border: 3px solid #ff6001;
  pointer-events: none;
  z-index: 2;
  box-sizing: border-box;
}

/* 장애물 */
.obstacle-item {
  z-index: 3;
  padding: 2px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.obstacle-svg {
  width: 100%;
  height: 100%;
}

.obs-block-body {
  fill: #ff6001;
  stroke: #ea580c;
  stroke-width: 1.2;
}

.obs-center-line {
  stroke: #c2410c;
  stroke-width: 1.5;
}

/* 차량 아이템 및 인터랙션 스타일 */
.vehicle-item {
  z-index: 4;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  transition: transform 0.15s ease;
}

/* 룰 1: 미배치 슬롯은 완전히 무색 회색 + 50% 투명도 처리 */
.vehicle-item.unplaced-slot {
  opacity: 0.5;
}

.vehicle-item.selected {
  outline: 2px solid #38bdf8;
  border-radius: 4px;
}

/* Deep Selector를 통해 하위 컴포넌트 내부 SVG에 스타일 적용 */
::v-deep .vehicle-svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.7));
}

/* 회색 / 빨간색 / 노란색 스킨 */
::v-deep .vehicle-item.gray .car-body-path {
  fill: #cbd5e1;
  stroke: #475569;
  stroke-width: 1.5;
}
::v-deep .vehicle-item.gray .car-glass-path {
  fill: #475569;
}
::v-deep .vehicle-item.gray .bus-body-rect {
  fill: #e2e8f0;
  stroke: #64748b;
  stroke-width: 1.5;
}

::v-deep .vehicle-item.red .car-body-path {
  fill: #dc2626;
  stroke: #7f1d1d;
  stroke-width: 1.5;
}
::v-deep .vehicle-item.red .car-glass-path {
  fill: #450a0a;
}

::v-deep .vehicle-item.yellow .car-body-path {
  fill: #eab308;
  stroke: #713f12;
  stroke-width: 1.5;
}
::v-deep .vehicle-item.yellow .car-glass-path {
  fill: #422006;
}

::v-deep .car-detail-line {
  stroke: rgba(0, 0, 0, 0.3);
  stroke-width: 1.2;
  fill: none;
}
::v-deep .car-mirror,
::v-deep .car-roof-point {
  fill: #334155;
}
::v-deep .bus-line {
  stroke: rgba(0, 0, 0, 0.35);
  stroke-width: 1.5;
}
::v-deep .bus-hatch-outer {
  fill: #94a3b8;
  stroke: #475569;
  stroke-width: 1.2;
}
::v-deep .bus-hatch-inner {
  fill: #f8fafc;
}
::v-deep .bus-grill line {
  stroke: rgba(0, 0, 0, 0.4);
  stroke-width: 1;
}

/* 룰 6: 라바콘 오버레이 */
.traffic-cone-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  z-index: 10;
  pointer-events: none;
}
.cone-svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.8));
}

/* 이동 경로 버튼 */
.move-guide-item {
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.move-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #38bdf8;
  color: #0f172a;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(56, 189, 248, 0.8);
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>
